import {
  GET_PROFILE, PROFILE_ERRORS, UPDATE_PROFILE, DELETE_PROFILE_SERVICE,
  UPDATE_PROFILE_SERVICE, UPDATE_PROFILE_SERVICE_STATUS, GET_FAVORITES,
  UPDATE_PROFILE_PAGE_STATUS, TOGGLE_FAVORITE
} from '../actions/types';

const initialState = {
  profile: {},
  favorites: [],
  loading: true,
  error: {}
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  const { servicios } = state.profile;

  switch (type) {
    case GET_PROFILE:
      return {
        ...state,
        profile: payload,
        loading: false,
        error: {}
      };
    case UPDATE_PROFILE_SERVICE:
      const services = servicios.map(srv => srv._id === payload._id ? payload : srv);
      state.profile.servicios = services;
      return {
        ...state,
        profile: state.profile,
        loading: false,
        error: {}
      };
    case UPDATE_PROFILE_SERVICE_STATUS:
      state.profile.servicios = payload;
      return {
        ...state,
        profile: state.profile,
        loading: false,
        error: {}
      }
    case UPDATE_PROFILE_PAGE_STATUS:
      return {
        ...state,
        profile: {
          ...state.profile,
          paginas: payload.paginas,
          ...(Array.isArray(payload.servicios) ? { servicios: payload.servicios } : {})
        },
        loading: false,
        error: {}
      }
    case DELETE_PROFILE_SERVICE:
      state.profile.servicios = payload
      return {
        ...state,
        profile: state.profile,
        loading: false,
        error: {}
      };
    case GET_FAVORITES:
      return {
        ...state,
        favorites: payload,
        loading: false
      }
    case TOGGLE_FAVORITE:
      return {
        ...state,
        favorites: state.favorites.filter(fav => payload.some(id => id.toString() === fav._id.toString())),
        loading: false
      }
    case PROFILE_ERRORS:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
